import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import MainHeader, { MENU_REPORT } from "../../components/common/MainHeader";
import { WOOD_IMPORT_GRADE_DISPLAY } from "../../constance/dataTypes";
import ReportDetail from "../../components/reports/ReportDetail";
import { URL_BARCODE } from "../../constance/urls";
import { formatComma } from "../../utils/stringFormat";
import ReportExportButton from "../../components/common/ReportExportButton";
import { Row, Col, DatePicker, Select, Button, Form, Typography } from "antd";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";

export default function ReportWoodImportOutGrade() {
  const { t } = useTranslation();
  const [queryParams, setQueryParams] = React.useState(null);

  const [form] = Form.useForm();
  const date = Form.useWatch("dateRange", form);
  const grade = Form.useWatch("wood_grade_options", form);
  const [errors, setErrors] = useState({});

  const ref = useRef();

  const wood_grade_options = [
    { value: "all", key: "all", label: t("all") },
    ...WOOD_IMPORT_GRADE_DISPLAY.map((grade) => {
      const text = String(grade).toLocaleUpperCase();
      console.log({ grade, text });
      return { value: grade, key: grade, label: text };
    }),
  ];

  const columns = React.useMemo(() => [
    { title: "ลูกค้า", dataIndex: "truck_company", width: 200 },
    { title: "ขนาดไม้", dataIndex: "mil_thick_code" },
    { title: "รหัสสินค้า", dataIndex: "wood_code" },
    { title: "จำนวน (ท่อน)", dataIndex: "amount" },
    { title: "ปริมาตร (ลบ.ฟ.)", dataIndex: "volume" },
    { title: "%", dataIndex: "percentage" },
    { title: "ราคาซื้อ", dataIndex: "buy_price" },
    { title: "ราคาขาย", dataIndex: "sell_price" },
    { title: "กำไร", dataIndex: "profit" },
  ]);

  const getQueryParams = () => {
    const values = form.getFieldsValue();
    const startDate = dayjs(values.dateRange[0]).format(DATE_FORMAT);
    const endDate = dayjs(values.dateRange[1]).format(DATE_FORMAT);
    const queryString = `date_after=${startDate}&date_before=${endDate}&grade=${grade}`;
    return queryString;
  };

  const validateForm = () => {
    const values = form.getFieldsValue();
    const newErrors = {};
    if (!values.dateRange || values.dateRange.length < 2)
      newErrors.dateRange = t("error_messages.validation.required");
    if (!grade) newErrors.grade = t("error_messages.validation.required");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  React.useEffect(() => {
    if (validateForm()) {
      if (ref.current) {
        const params = getQueryParams();
        ref.current.refetch(params);
        setQueryParams(params);
      }
    }
  }, [date, grade]);

  return (
    <div style={{ margin: "24px", marginTop: "7em" }}>
      <MainHeader activeItem={MENU_REPORT} />
      <Typography.Title level={2}>
        {t("menus.report_menus.wood_import_menus.wood_import_out_grade")}
      </Typography.Title>
      <Form
        layout="horizontal"
        form={form}
        initialValues={{
          wood_grade_options: "all",
          dateRange: [],
        }}
      >
        <Row gutter={16}>
          <Col sm={24} md={24} lg={6}>
            <Form.Item
              label={t("filter")}
              name="dateRange"
              rules={[{ required: true, message: t("กรุณาเลือกช่วงเวลา") }]}
            >
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                placeholder={[
                  t("searchs.placeholders.startDate"),
                  t("searchs.placeholders.endDate"),
                ]}
                format={HUMAN_DATE_FORMAT}
              />
            </Form.Item>
          </Col>
          <Col sm={24} md={24} lg={6}>
            <Form.Item
              label={t("wood_imports.grade")}
              name="wood_grade_options"
            >
              <Select options={wood_grade_options} />
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: "right" }}>
          {["pdf", "excel"].map((type) => (
            <ReportExportButton
              url={`${URL_BARCODE.REPORT_WOOD_IMPORT_OUT_GRADE_EXPORT}${type}/?${queryParams}`}
              type={type}
              title={`${t(
                "menus.report_menus.wood_import_menus.wood_import_out_grade"
              )}.....`}
              disabled={queryParams == null}
            />
          ))}
        </div>
      </Form>
      <ReportDetail
        ref={ref}
        reportUrl={URL_BARCODE.REPORT_WOOD_IMPORT_OUT_GRADE}
        columns={columns}
        isCustomSetData
        customSetData={(datas) => {
          const newData = [];
          let sumAmount = 0;
          let sumVolume = 0;
          for (let data of datas) {
            for (let [
              woodThickGroupIndex,
              woodThickGroupReport,
            ] of data.report.entries()) {
              for (let [
                woodCodeGroupIndex,
                woodCodeGroupReport,
              ] of woodThickGroupReport.report.entries()) {
                let obj = woodCodeGroupReport;
                if (woodCodeGroupIndex == 0) {
                  if (woodThickGroupIndex == 0) {
                    obj.truck_company = data.truck_company;
                  }
                  obj.mil_thick_code = woodThickGroupReport.mil_thick_code;
                }
                newData.push(obj);
              }
              let amount = woodThickGroupReport.report.reduce(
                (prev, cur) => prev + Number(cur.amount),
                Number(0)
              );
              let volume = woodThickGroupReport.report.reduce(
                (prev, cur) => prev + Number(cur.volume),
                Number(0)
              );
              newData.push({
                wood_code: "รวม",
                amount: amount,
                volume: formatComma(volume, 4),
                percentage: volume,
              });
              sumAmount += amount;
              sumVolume += volume;
            }
          }
          newData.forEach((e) => {
            if (e.wood_code === "รวม")
              e.percentage = formatComma((e.percentage * 100) / sumVolume);
          });
          newData.push({
            truck_company: "รวมทั้งหมด",
            amount: sumAmount,
            volume: formatComma(sumVolume, 4),
          });
          return newData;
        }}
      />
    </div>
  );
}
